export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const isAndroid = () => {
  const u = navigator.userAgent

  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('XiaoMi') > -1 || u.indexOf('Linux') > -1
}

export const isIOS = () => {
  const u = navigator.userAgent

  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

export const isMac = () => {
  const p = navigator.platform

  return p.toUpperCase().indexOf('MAC') >= 0
}

export const isWindows = () => {
  const p = navigator.platform

  return p.toUpperCase().indexOf('WIN') >= 0
}

export const isLinux = () => {
  const p = navigator.platform

  return p.toUpperCase().indexOf('LINUX') >= 0
}

export const countDownMinutes = isMobile() ? 4 : 9



// WEBPACK FOOTER //
// ./src/lib/fun.js